const steps = {
  DETAILS: 1,
  GROUPS: 2,
  DOWNLOAD: 3,
}

export default steps
